export default __webpack_public_path__ + "static/platform-back-21206557eb86f9ee171e3fe093e2ab9d.webp";